import { z } from 'zod';
import { singleDieSchema, twoDiceSumSchema, uniquePlayerColorsArraySchema } from './SharedZodSchemas.ts';
import { validateState } from './ValidateState.ts';
import { PlayerColor } from './PlayerState.ts';
import { CardDistributionType, CardEnum } from './CardState.ts';
import { TileHexType, tileHexDiceNumberSchema } from './map-state/TileHexState.ts';
import { TileEdgeType } from './map-state/TileEdgeState.ts';
import { CityImprovementTypes } from './mechanic-states/MechanicCityImprovements.ts';
export var GameLogPieceEnum = /*#__PURE__*/ function(GameLogPieceEnum) {
    GameLogPieceEnum[GameLogPieceEnum["Road"] = 0] = "Road";
    GameLogPieceEnum[GameLogPieceEnum["Ship"] = 1] = "Ship";
    GameLogPieceEnum[GameLogPieceEnum["Settlement"] = 2] = "Settlement";
    GameLogPieceEnum[GameLogPieceEnum["City"] = 3] = "City";
    GameLogPieceEnum[GameLogPieceEnum["CityWall"] = 4] = "CityWall";
    GameLogPieceEnum[GameLogPieceEnum["Robber"] = 5] = "Robber";
    GameLogPieceEnum[GameLogPieceEnum["Pirate"] = 6] = "Pirate";
    return GameLogPieceEnum;
}({});
export var GameLogAchievementEnum = /*#__PURE__*/ function(GameLogAchievementEnum) {
    GameLogAchievementEnum[GameLogAchievementEnum["LongestRoad"] = 0] = "LongestRoad";
    GameLogAchievementEnum[GameLogAchievementEnum["LargestArmy"] = 1] = "LargestArmy";
    return GameLogAchievementEnum;
}({});
export var GameLogType = /*#__PURE__*/ function(GameLogType) {
    GameLogType[GameLogType["PlayerReconnecting"] = 0] = "PlayerReconnecting";
    GameLogType[GameLogType["BoughtDevelopmentCard"] = 1] = "BoughtDevelopmentCard";
    GameLogType[GameLogType["WelcomeMessage"] = 2] = "WelcomeMessage";
    GameLogType[GameLogType["StartedSpectating"] = 3] = "StartedSpectating";
    GameLogType[GameLogType["PlayerPlacedPiece"] = 4] = "PlayerPlacedPiece";
    GameLogType[GameLogType["BuiltPiece"] = 5] = "BuiltPiece";
    GameLogType[GameLogType["PlayerMovedPiece"] = 6] = "PlayerMovedPiece";
    GameLogType[GameLogType["UpgradedKnight"] = 7] = "UpgradedKnight";
    GameLogType[GameLogType["ActivatedKnight"] = 8] = "ActivatedKnight";
    GameLogType[GameLogType["RemovedKnight"] = 9] = "RemovedKnight";
    GameLogType[GameLogType["RolledDice"] = 10] = "RolledDice";
    GameLogType[GameLogType["MovedRobber"] = 11] = "MovedRobber";
    GameLogType[GameLogType["PlacedMetropolis"] = 12] = "PlacedMetropolis";
    GameLogType[GameLogType["ReceivedCard"] = 13] = "ReceivedCard";
    GameLogType[GameLogType["StolenResourceCardThief"] = 14] = "StolenResourceCardThief";
    GameLogType[GameLogType["StolenResourceCardVictim"] = 15] = "StolenResourceCardVictim";
    GameLogType[GameLogType["StolenResourceCardClosed"] = 16] = "StolenResourceCardClosed";
    GameLogType[GameLogType["StolenDevelopmentCardThief"] = 17] = "StolenDevelopmentCardThief";
    GameLogType[GameLogType["StolenDevelopmentCardVictim"] = 18] = "StolenDevelopmentCardVictim";
    GameLogType[GameLogType["StolenDevelopmentCardClosed"] = 19] = "StolenDevelopmentCardClosed";
    GameLogType[GameLogType["PlayerPlayedDevelopmentCard"] = 20] = "PlayerPlayedDevelopmentCard";
    GameLogType[GameLogType["YearOfPlentyTookFromBank"] = 21] = "YearOfPlentyTookFromBank";
    GameLogType[GameLogType["LeftTheGame"] = 22] = "LeftTheGame";
    GameLogType[GameLogType["WasInactiveAndKicked"] = 23] = "WasInactiveAndKicked";
    GameLogType[GameLogType["Disconnected"] = 24] = "Disconnected";
    GameLogType[GameLogType["StoppedSpectating"] = 25] = "StoppedSpectating";
    GameLogType[GameLogType["KarmaPenaltyRemoved"] = 26] = "KarmaPenaltyRemoved";
    GameLogType[GameLogType["KarmaSystemDisabledDueToPlayersLeaving"] = 27] = "KarmaSystemDisabledDueToPlayersLeaving";
    GameLogType[GameLogType["KarmaSystemInactiveCannotVoteToDisable"] = 28] = "KarmaSystemInactiveCannotVoteToDisable";
    GameLogType[GameLogType["KarmaSystemIsAlreadyDisabled"] = 29] = "KarmaSystemIsAlreadyDisabled";
    GameLogType[GameLogType["YouCantStartVoteBecauseYouAreTheOnlyPlayerLeft"] = 30] = "YouCantStartVoteBecauseYouAreTheOnlyPlayerLeft";
    GameLogType[GameLogType["YouCantStartVoteDueToYourLeaverStatus"] = 31] = "YouCantStartVoteDueToYourLeaverStatus";
    GameLogType[GameLogType["YouCanOnlyStartAVoteToDisableKarmaOnce"] = 32] = "YouCanOnlyStartAVoteToDisableKarmaOnce";
    GameLogType[GameLogType["KarmaSystemVoteToDisableSucceeded"] = 33] = "KarmaSystemVoteToDisableSucceeded";
    GameLogType[GameLogType["KarmaSystemVoteToDisableDeclined"] = 34] = "KarmaSystemVoteToDisableDeclined";
    GameLogType[GameLogType["ThereIsAlreadyAnActiveVote"] = 35] = "ThereIsAlreadyAnActiveVote";
    GameLogType[GameLogType["PlayerStartedAVoteToDisableKarma"] = 36] = "PlayerStartedAVoteToDisableKarma";
    GameLogType[GameLogType["GameEndMessage"] = 37] = "GameEndMessage";
    GameLogType[GameLogType["GameEndChatDisabled"] = 38] = "GameEndChatDisabled";
    GameLogType[GameLogType["PlayerCouldNotStealFrom"] = 39] = "PlayerCouldNotStealFrom";
    GameLogType[GameLogType["GameCrashedZero"] = 40] = "GameCrashedZero";
    GameLogType[GameLogType["GameCrashedOne"] = 41] = "GameCrashedOne";
    GameLogType[GameLogType["GameCrashedTwo"] = 42] = "GameCrashedTwo";
    GameLogType[GameLogType["GameCrashedThree"] = 43] = "GameCrashedThree";
    GameLogType[GameLogType["Separator"] = 44] = "Separator";
    GameLogType[GameLogType["PlayerWonTheGame"] = 45] = "PlayerWonTheGame";
    GameLogType[GameLogType["GameEndedDueToServerRestart"] = 46] = "GameEndedDueToServerRestart";
    GameLogType[GameLogType["ResourceDistribution"] = 47] = "ResourceDistribution";
    /** @deprecated Used by existing games and replays. Use NotEnoughCardsInBankToCompleteDistribution for new logs. */ GameLogType[GameLogType["NotEnoughCardsInBankToDistribute"] = 48] = "NotEnoughCardsInBankToDistribute";
    GameLogType[GameLogType["TileBlockedByRobber"] = 49] = "TileBlockedByRobber";
    GameLogType[GameLogType["PlayersSelectingResourcesFromAqueduct"] = 50] = "PlayersSelectingResourcesFromAqueduct";
    GameLogType[GameLogType["BotSelectingAqueductResourcesFor"] = 51] = "BotSelectingAqueductResourcesFor";
    GameLogType[GameLogType["NotEnoughProgressCardsInBankToDistribute"] = 52] = "NotEnoughProgressCardsInBankToDistribute";
    GameLogType[GameLogType["PlayersDiscardingProgressCards"] = 53] = "PlayersDiscardingProgressCards";
    GameLogType[GameLogType["PlayerDiscarded"] = 55] = "PlayerDiscarded";
    GameLogType[GameLogType["PlayersSelectingResourceFromGoldTile"] = 56] = "PlayersSelectingResourceFromGoldTile";
    GameLogType[GameLogType["FriendlyPirateActive"] = 57] = "FriendlyPirateActive";
    GameLogType[GameLogType["BotIsSelectingWhereToPlacePieceFor"] = 58] = "BotIsSelectingWhereToPlacePieceFor";
    GameLogType[GameLogType["RobberDisabledUntilFirstBarbarianAttack"] = 59] = "RobberDisabledUntilFirstBarbarianAttack";
    GameLogType[GameLogType["FriendlyRobberActive"] = 60] = "FriendlyRobberActive";
    GameLogType[GameLogType["LostMetropolis"] = 61] = "LostMetropolis";
    GameLogType[GameLogType["PlayerUpgradedImprovementTo"] = 62] = "PlayerUpgradedImprovementTo";
    GameLogType[GameLogType["BotIsSelectingGoldTileResourceFor"] = 63] = "BotIsSelectingGoldTileResourceFor";
    GameLogType[GameLogType["BotIsSelectingCardsToDiscardFor"] = 64] = "BotIsSelectingCardsToDiscardFor";
    GameLogType[GameLogType["PlayerSettledOnForeignLand"] = 65] = "PlayerSettledOnForeignLand";
    GameLogType[GameLogType["PlayerReceivedAchievement"] = 66] = "PlayerReceivedAchievement";
    GameLogType[GameLogType["PlayerLostAchievement"] = 67] = "PlayerLostAchievement";
    GameLogType[GameLogType["PlayerPassedAchievementTo"] = 68] = "PlayerPassedAchievementTo";
    GameLogType[GameLogType["PlayerMovedMerchantTo"] = 69] = "PlayerMovedMerchantTo";
    GameLogType[GameLogType["PlayerLostPossessionOfMerchant"] = 70] = "PlayerLostPossessionOfMerchant";
    GameLogType[GameLogType["BotIsSelectingWhereToPlaceMerchantFor"] = 71] = "BotIsSelectingWhereToPlaceMerchantFor";
    GameLogType[GameLogType["BotIsPlacing"] = 72] = "BotIsPlacing";
    GameLogType[GameLogType["BotIsSelectingWhoToRobFor"] = 73] = "BotIsSelectingWhoToRobFor";
    GameLogType[GameLogType["NoPlayerToStealFrom"] = 74] = "NoPlayerToStealFrom";
    GameLogType[GameLogType["SkippingSpecialBuildPhase"] = 75] = "SkippingSpecialBuildPhase";
    GameLogType[GameLogType["PlayerEnteredSpecialBuildPhase"] = 76] = "PlayerEnteredSpecialBuildPhase";
    GameLogType[GameLogType["BotIsSelectingProgressCardFor"] = 77] = "BotIsSelectingProgressCardFor";
    GameLogType[GameLogType["PlayerIsSpyingPlayer"] = 78] = "PlayerIsSpyingPlayer";
    GameLogType[GameLogType["PlayersDefeatedBarbarians"] = 79] = "PlayersDefeatedBarbarians";
    GameLogType[GameLogType["PlayerAwardedDefenderOfColonist"] = 80] = "PlayerAwardedDefenderOfColonist";
    GameLogType[GameLogType["PlayersSelectingProgressCard"] = 81] = "PlayersSelectingProgressCard";
    GameLogType[GameLogType["BotIsSelectingPieceToDestroyFor"] = 82] = "BotIsSelectingPieceToDestroyFor";
    GameLogType[GameLogType["BarbariansAttackedButNoCityToPillage"] = 83] = "BarbariansAttackedButNoCityToPillage";
    GameLogType[GameLogType["PlayersDefeatedByBarbarians"] = 84] = "PlayersDefeatedByBarbarians";
    GameLogType[GameLogType["PlayersPieceDestroyedByBarbarians"] = 85] = "PlayersPieceDestroyedByBarbarians";
    GameLogType[GameLogType["PlayerStoleUsingMonopoly"] = 86] = "PlayerStoleUsingMonopoly";
    GameLogType[GameLogType["BotIsPlacingPieceFor"] = 87] = "BotIsPlacingPieceFor";
    GameLogType[GameLogType["BotIsSelectingWhereToPlaceKnightFor"] = 88] = "BotIsSelectingWhereToPlaceKnightFor";
    GameLogType[GameLogType["PlayerUsedPieceToMovePiece"] = 89] = "PlayerUsedPieceToMovePiece";
    GameLogType[GameLogType["PlayerDisplacedPiece"] = 90] = "PlayerDisplacedPiece";
    GameLogType[GameLogType["BotSelectingWhereToMoveKnightFor"] = 91] = "BotSelectingWhereToMoveKnightFor";
    GameLogType[GameLogType["PlayerRemovedPlayersKnight"] = 92] = "PlayerRemovedPlayersKnight";
    GameLogType[GameLogType["BotSelectingKnightToRemoveFor"] = 93] = "BotSelectingKnightToRemoveFor";
    GameLogType[GameLogType["BotSelectingKnightToUpgradeFor"] = 94] = "BotSelectingKnightToUpgradeFor";
    GameLogType[GameLogType["PlayerReceivedVPProgressCard"] = 95] = "PlayerReceivedVPProgressCard";
    GameLogType[GameLogType["PlayerSelectedPlayer"] = 96] = "PlayerSelectedPlayer";
    GameLogType[GameLogType["PlayerRepositioningEdgePiece"] = 97] = "PlayerRepositioningEdgePiece";
    GameLogType[GameLogType["PlayerRemovedEdgePiece"] = 98] = "PlayerRemovedEdgePiece";
    GameLogType[GameLogType["BotIsSelectingEdgePieceToRemoveFor"] = 99] = "BotIsSelectingEdgePieceToRemoveFor";
    GameLogType[GameLogType["BotSelectingResourcesFor"] = 100] = "BotSelectingResourcesFor";
    GameLogType[GameLogType["BotSelectingDiceFor"] = 101] = "BotSelectingDiceFor";
    GameLogType[GameLogType["PlayerSwappedTileNumbers"] = 102] = "PlayerSwappedTileNumbers";
    GameLogType[GameLogType["ExchangedCardsThief"] = 103] = "ExchangedCardsThief";
    GameLogType[GameLogType["ExchangedCardsVictim"] = 104] = "ExchangedCardsVictim";
    GameLogType[GameLogType["ExchangedCardsClosed"] = 105] = "ExchangedCardsClosed";
    GameLogType[GameLogType["PlayerIsStealingFrom"] = 106] = "PlayerIsStealingFrom";
    GameLogType[GameLogType["PlayerSelectedCard"] = 107] = "PlayerSelectedCard";
    GameLogType[GameLogType["BotLogicNotSupportedForCitiesAndKnights"] = 108] = "BotLogicNotSupportedForCitiesAndKnights";
    GameLogType[GameLogType["PlayerUnlockedAqueduct"] = 109] = "PlayerUnlockedAqueduct";
    GameLogType[GameLogType["PlayerUnlockedTradingHouse"] = 110] = "PlayerUnlockedTradingHouse";
    GameLogType[GameLogType["PlayerUnlockedFortress"] = 111] = "PlayerUnlockedFortress";
    GameLogType[GameLogType["PlayerResigned"] = 112] = "PlayerResigned";
    GameLogType[GameLogType["PlayerStartedEmbargo"] = 113] = "PlayerStartedEmbargo";
    GameLogType[GameLogType["PlayerEndedEmbargo"] = 114] = "PlayerEndedEmbargo";
    GameLogType[GameLogType["PlayerTradedWithPlayer"] = 115] = "PlayerTradedWithPlayer";
    GameLogType[GameLogType["PlayerTradedWithBank"] = 116] = "PlayerTradedWithBank";
    GameLogType[GameLogType["PlayerWantsToCounterOfferWith"] = 117] = "PlayerWantsToCounterOfferWith";
    GameLogType[GameLogType["PlayerWantsToTradeWith"] = 118] = "PlayerWantsToTradeWith";
    GameLogType[GameLogType["PlayerCreatedRematch"] = 119] = "PlayerCreatedRematch";
    GameLogType[GameLogType["PlayersJoinedRematch"] = 120] = "PlayersJoinedRematch";
    GameLogType[GameLogType["YouCanOnlyStartAVoteToPauseXTimes"] = 121] = "YouCanOnlyStartAVoteToPauseXTimes";
    GameLogType[GameLogType["GamePaused"] = 122] = "GamePaused";
    GameLogType[GameLogType["GameResumed"] = 123] = "GameResumed";
    GameLogType[GameLogType["PauseSystemPlayerStartedVotePause"] = 124] = "PauseSystemPlayerStartedVotePause";
    GameLogType[GameLogType["PauseSystemPlayerStartedVoteResume"] = 125] = "PauseSystemPlayerStartedVoteResume";
    GameLogType[GameLogType["PauseSystemVoteSucceededPause"] = 126] = "PauseSystemVoteSucceededPause";
    GameLogType[GameLogType["PauseSystemVoteSucceededResume"] = 127] = "PauseSystemVoteSucceededResume";
    GameLogType[GameLogType["PauseSystemVoteDeclinedPause"] = 128] = "PauseSystemVoteDeclinedPause";
    GameLogType[GameLogType["PauseSystemVoteDeclinedResume"] = 129] = "PauseSystemVoteDeclinedResume";
    GameLogType[GameLogType["YouAreLastPlayerYouWillWinIfOpponentDoesNotReconnect"] = 130] = "YouAreLastPlayerYouWillWinIfOpponentDoesNotReconnect";
    GameLogType[GameLogType["VoteHasBeenCanceledBecauseGameEnded"] = 131] = "VoteHasBeenCanceledBecauseGameEnded";
    GameLogType[GameLogType["PlayerPlacedKnight"] = 132] = "PlayerPlacedKnight";
    GameLogType[GameLogType["PlayerMovedKnight"] = 133] = "PlayerMovedKnight";
    GameLogType[GameLogType["ChatCommandGetAllResources"] = 134] = "ChatCommandGetAllResources";
    GameLogType[GameLogType["ChatCommandGetCard"] = 135] = "ChatCommandGetCard";
    GameLogType[GameLogType["ChatCommandRollAll"] = 136] = "ChatCommandRollAll";
    GameLogType[GameLogType["ChatCommandRollDice"] = 137] = "ChatCommandRollDice";
    GameLogType[GameLogType["ChatCommandRollNextDice"] = 138] = "ChatCommandRollNextDice";
    GameLogType[GameLogType["CantStealPlayersDontHaveCards"] = 139] = "CantStealPlayersDontHaveCards";
    GameLogType[GameLogType["PermanentlyKickedForGoingAFKTooManyTime"] = 140] = "PermanentlyKickedForGoingAFKTooManyTime";
    GameLogType[GameLogType["DiceRolledAutomatically"] = 141] = "DiceRolledAutomatically";
    GameLogType[GameLogType["ChatCommandDiscardAll"] = 142] = "ChatCommandDiscardAll";
    GameLogType[GameLogType["NoResourcesInBankToDistribute"] = 143] = "NoResourcesInBankToDistribute";
    GameLogType[GameLogType["PlayerSelectsFewerResourcesDueToBankShortage"] = 144] = "PlayerSelectsFewerResourcesDueToBankShortage";
    GameLogType[GameLogType["NotEnoughCardsInBankToCompleteDistribution"] = 145] = "NotEnoughCardsInBankToCompleteDistribution";
    return GameLogType;
}({});
export const gameLogKnightInformationSchema = z.object({
    ownerColor: z.enum(PlayerColor),
    level: z.number().int().min(1).max(3),
    isActivated: z.boolean()
}).strict();
export const gameLogTileInformationSchema = z.object({
    tileType: z.enum(TileHexType),
    diceNumber: tileHexDiceNumberSchema,
    resourceType: z.enum(CardEnum).exactOptional()
}).strict();
export const gameLogSchema = z.discriminatedUnion('type', [
    z.object({
        type: z.literal(0),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(1),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(2),
        isDiscord: z.boolean()
    }).strict(),
    z.object({
        type: z.literal(3),
        username: z.string()
    }).strict(),
    z.object({
        type: z.literal(4),
        playerColor: z.enum(PlayerColor),
        pieceEnum: z.enum(GameLogPieceEnum)
    }).strict(),
    z.object({
        type: z.literal(5),
        playerColor: z.enum(PlayerColor),
        pieceEnum: z.enum(GameLogPieceEnum),
        isVp: z.boolean()
    }).strict(),
    z.object({
        type: z.literal(6),
        playerColor: z.enum(PlayerColor),
        pieceEnum: z.enum(GameLogPieceEnum)
    }).strict(),
    z.object({
        type: z.literal(7),
        playerColor: z.enum(PlayerColor),
        oldKnightInfo: gameLogKnightInformationSchema,
        newKnightInfo: gameLogKnightInformationSchema
    }).strict(),
    z.object({
        type: z.literal(8),
        playerColor: z.enum(PlayerColor),
        knightInfo: gameLogKnightInformationSchema
    }).strict(),
    z.object({
        type: z.literal(9),
        playerColor: z.enum(PlayerColor),
        knightInfo: gameLogKnightInformationSchema
    }).strict(),
    z.object({
        type: z.literal(10),
        playerColor: z.enum(PlayerColor),
        firstDice: singleDieSchema,
        secondDice: singleDieSchema,
        eventDice: singleDieSchema.optional()
    }).strict(),
    z.object({
        type: z.literal(11),
        playerColor: z.enum(PlayerColor),
        pieceEnum: z.enum(GameLogPieceEnum),
        tileInfo: gameLogTileInformationSchema
    }).strict(),
    z.object({
        type: z.literal(12),
        playerColor: z.enum(PlayerColor),
        metropolisType: z.enum(CityImprovementTypes)
    }).strict(),
    z.object({
        type: z.literal(13),
        playerColor: z.enum(PlayerColor),
        cardEnum: z.enum(CardEnum)
    }).strict(),
    z.object({
        type: z.literal(14),
        playerColor: z.enum(PlayerColor),
        cardEnums: z.array(z.enum(CardEnum))
    }).strict(),
    z.object({
        type: z.literal(15),
        playerColor: z.enum(PlayerColor),
        cardEnums: z.array(z.enum(CardEnum))
    }).strict(),
    z.object({
        type: z.literal(16),
        playerColorThief: z.enum(PlayerColor),
        playerColorVictim: z.enum(PlayerColor),
        cardBacks: z.array(z.enum(CardEnum))
    }).strict(),
    z.object({
        type: z.literal(17),
        playerColor: z.enum(PlayerColor),
        cardEnum: z.enum(CardEnum)
    }).strict(),
    z.object({
        type: z.literal(18),
        playerColor: z.enum(PlayerColor),
        cardEnum: z.enum(CardEnum)
    }).strict(),
    z.object({
        type: z.literal(19),
        playerColorThief: z.enum(PlayerColor),
        playerColorVictim: z.enum(PlayerColor),
        cardBack: z.enum(CardEnum)
    }).strict(),
    z.object({
        type: z.literal(20),
        playerColor: z.enum(PlayerColor),
        cardEnum: z.enum(CardEnum)
    }).strict(),
    z.object({
        type: z.literal(21),
        playerColor: z.enum(PlayerColor),
        cardEnums: z.array(z.enum(CardEnum))
    }).strict(),
    z.object({
        type: z.literal(22),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(23),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(24),
        playerColor: z.enum(PlayerColor),
        is10SecondRuleDisabled: z.boolean()
    }).strict(),
    z.object({
        type: z.literal(25),
        username: z.string()
    }).strict(),
    z.object({
        type: z.literal(26)
    }).strict(),
    z.object({
        type: z.literal(27)
    }).strict(),
    z.object({
        type: z.literal(28)
    }).strict(),
    z.object({
        type: z.literal(29)
    }).strict(),
    z.object({
        type: z.literal(30)
    }).strict(),
    z.object({
        type: z.literal(31)
    }).strict(),
    z.object({
        type: z.literal(32)
    }).strict(),
    z.object({
        type: z.literal(33)
    }).strict(),
    z.object({
        type: z.literal(34)
    }).strict(),
    z.object({
        type: z.literal(35)
    }).strict(),
    z.object({
        type: z.literal(36),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(37)
    }).strict(),
    z.object({
        type: z.literal(38)
    }).strict(),
    z.object({
        type: z.literal(39),
        playerColorStealing: z.enum(PlayerColor),
        playerColorVictim: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(40)
    }).strict(),
    z.object({
        type: z.literal(41)
    }).strict(),
    z.object({
        type: z.literal(42),
        dateString: z.string()
    }).strict(),
    z.object({
        type: z.literal(43)
    }).strict(),
    z.object({
        type: z.literal(44)
    }).strict(),
    z.object({
        type: z.literal(45),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(46)
    }).strict(),
    z.object({
        type: z.literal(47),
        playerColor: z.enum(PlayerColor),
        cardsToBroadcast: z.array(z.enum(CardEnum)),
        distributionType: z.enum(CardDistributionType)
    }).strict(),
    z.object({
        type: z.literal(48),
        cardEnum: z.enum(CardEnum),
        count: z.number().int().nonnegative().exactOptional(),
        bankCount: z.number().int().nonnegative().exactOptional()
    }).strict(),
    z.object({
        type: z.literal(145),
        cardEnum: z.enum(CardEnum),
        count: z.number().int().nonnegative(),
        bankCount: z.number().int().nonnegative(),
        distributedCount: z.number().int().nonnegative()
    }).strict(),
    z.object({
        type: z.literal(49),
        tileInfo: gameLogTileInformationSchema
    }).strict(),
    z.object({
        type: z.literal(50),
        playerColors: uniquePlayerColorsArraySchema
    }).strict(),
    z.object({
        type: z.literal(51),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(52)
    }).strict(),
    z.object({
        type: z.literal(53),
        playerColors: uniquePlayerColorsArraySchema
    }).strict(),
    z.object({
        type: z.literal(55),
        playerColor: z.enum(PlayerColor),
        cardEnums: z.array(z.enum(CardEnum)),
        areResourceCards: z.boolean()
    }).strict(),
    z.object({
        type: z.literal(56),
        playerColors: uniquePlayerColorsArraySchema
    }).strict(),
    z.object({
        type: z.literal(57),
        all: z.boolean()
    }).strict(),
    z.object({
        type: z.literal(58),
        playerColor: z.enum(PlayerColor),
        pieceEnum: z.enum(GameLogPieceEnum)
    }).strict(),
    z.object({
        type: z.literal(59)
    }).strict(),
    z.object({
        type: z.literal(60),
        all: z.boolean()
    }).strict(),
    z.object({
        type: z.literal(61),
        playerColor: z.enum(PlayerColor),
        metropolisType: z.enum(CityImprovementTypes)
    }).strict(),
    z.object({
        type: z.literal(62),
        playerColor: z.enum(PlayerColor),
        improvementType: z.enum(CityImprovementTypes),
        newCityLevel: z.number().int().min(1)
    }).strict(),
    z.object({
        type: z.literal(63),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(64),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(65),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(66),
        playerColor: z.enum(PlayerColor),
        achievementEnum: z.enum(GameLogAchievementEnum)
    }).strict(),
    z.object({
        type: z.literal(67),
        playerColor: z.enum(PlayerColor),
        achievementEnum: z.enum(GameLogAchievementEnum)
    }).strict(),
    z.object({
        type: z.literal(68),
        playerColorOld: z.enum(PlayerColor),
        playerColorNew: z.enum(PlayerColor),
        achievementEnum: z.enum(GameLogAchievementEnum)
    }).strict(),
    z.object({
        type: z.literal(69),
        playerColor: z.enum(PlayerColor),
        tileInfo: gameLogTileInformationSchema,
        isMerchantOwnerDisplacingMerchant: z.boolean()
    }).strict(),
    z.object({
        type: z.literal(70),
        playerColor: z.enum(PlayerColor),
        merchantOwnerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(71),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(72),
        pieceEnum: z.union([
            z.literal(0),
            z.literal(1)
        ]),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(73),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(74)
    }).strict(),
    z.object({
        type: z.literal(75)
    }).strict(),
    z.object({
        type: z.literal(76),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(77),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(78),
        playerColor: z.enum(PlayerColor),
        playerColorVictim: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(79)
    }).strict(),
    z.object({
        type: z.literal(80),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(81),
        playerColors: uniquePlayerColorsArraySchema
    }).strict(),
    z.object({
        type: z.literal(82),
        playerColor: z.enum(PlayerColor),
        pieceEnum: z.enum(GameLogPieceEnum)
    }).strict(),
    z.object({
        type: z.literal(83)
    }).strict(),
    z.object({
        type: z.literal(84)
    }).strict(),
    z.object({
        type: z.literal(85),
        playerColor: z.enum(PlayerColor),
        pieceEnum: z.enum(GameLogPieceEnum)
    }).strict(),
    z.object({
        type: z.literal(86),
        playerColor: z.enum(PlayerColor),
        amountStolen: z.number().int().nonnegative(),
        cardEnum: z.enum(CardEnum)
    }).strict(),
    z.object({
        type: z.literal(87),
        playerColor: z.enum(PlayerColor),
        pieceEnum: z.enum(GameLogPieceEnum)
    }).strict(),
    z.object({
        type: z.literal(88),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(89),
        playerColor: z.enum(PlayerColor),
        knightInfo: gameLogKnightInformationSchema,
        isMovedPieceRobber: z.boolean()
    }).strict(),
    z.object({
        type: z.literal(90),
        playerColor: z.enum(PlayerColor),
        displacerKnightInfo: gameLogKnightInformationSchema,
        enemyKnightInfo: gameLogKnightInformationSchema
    }).strict(),
    z.object({
        type: z.literal(91),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(92),
        playerColor: z.enum(PlayerColor),
        playerColorLosingKnight: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(93),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(94),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(95),
        playerColor: z.enum(PlayerColor),
        cardEnum: z.enum(CardEnum)
    }).strict(),
    z.object({
        type: z.literal(96),
        playerColor: z.enum(PlayerColor),
        playerColorSelected: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(97),
        playerColor: z.enum(PlayerColor),
        edgeType: z.enum(TileEdgeType)
    }).strict(),
    z.object({
        type: z.literal(98),
        playerColor: z.enum(PlayerColor),
        playerColorLosingPiece: z.enum(PlayerColor),
        edgeType: z.enum(TileEdgeType)
    }).strict(),
    z.object({
        type: z.literal(99),
        playerColor: z.enum(PlayerColor),
        edgeType: z.enum(TileEdgeType)
    }).strict(),
    z.object({
        type: z.literal(100),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(101),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(102),
        playerColor: z.enum(PlayerColor),
        firstTileInfo: gameLogTileInformationSchema,
        secondTileInfo: gameLogTileInformationSchema
    }).strict(),
    z.object({
        type: z.literal(103),
        playerColor: z.enum(PlayerColor),
        givenCardEnum: z.enum(CardEnum),
        receivedCardEnum: z.enum(CardEnum)
    }).strict(),
    z.object({
        type: z.literal(104),
        playerColor: z.enum(PlayerColor),
        givenCardEnum: z.enum(CardEnum),
        receivedCardEnum: z.enum(CardEnum)
    }).strict(),
    z.object({
        type: z.literal(105),
        playerColorThief: z.enum(PlayerColor),
        playerColorVictim: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(106),
        playerColor: z.enum(PlayerColor),
        playerColorVictim: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(107),
        playerColor: z.enum(PlayerColor),
        cardEnum: z.enum(CardEnum)
    }).strict(),
    z.object({
        type: z.literal(108)
    }).strict(),
    z.object({
        type: z.literal(109),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(110),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(111),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(112),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(113),
        playerColor: z.enum(PlayerColor),
        embargoedPlayerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(114),
        playerColor: z.enum(PlayerColor),
        embargoedPlayerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(115),
        playerColor: z.enum(PlayerColor),
        acceptingPlayerColor: z.enum(PlayerColor),
        givenCardEnums: z.array(z.enum(CardEnum)),
        receivedCardEnums: z.array(z.enum(CardEnum))
    }).strict(),
    z.object({
        type: z.literal(116),
        playerColor: z.enum(PlayerColor),
        givenCardEnums: z.array(z.enum(CardEnum)),
        receivedCardEnums: z.array(z.enum(CardEnum))
    }).strict(),
    z.object({
        type: z.literal(117),
        playerColorCreator: z.enum(PlayerColor),
        playerColorOffered: z.enum(PlayerColor),
        wantedCardEnums: z.array(z.enum(CardEnum)),
        offeredCardEnums: z.array(z.enum(CardEnum))
    }).strict(),
    z.object({
        type: z.literal(118),
        playerColor: z.enum(PlayerColor),
        wantedCardEnums: z.array(z.enum(CardEnum)),
        offeredCardEnums: z.array(z.enum(CardEnum))
    }).strict(),
    z.object({
        type: z.literal(119),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(120),
        count: z.number().int().nonnegative(),
        playerUsernames: z.string()
    }).strict(),
    z.object({
        type: z.literal(121),
        count: z.number().int().nonnegative()
    }).strict(),
    z.object({
        type: z.literal(122)
    }).strict(),
    z.object({
        type: z.literal(123)
    }).strict(),
    z.object({
        type: z.literal(124),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(125),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(126)
    }).strict(),
    z.object({
        type: z.literal(127)
    }).strict(),
    z.object({
        type: z.literal(128)
    }).strict(),
    z.object({
        type: z.literal(129)
    }).strict(),
    z.object({
        type: z.literal(130),
        count: z.number().int().nonnegative()
    }).strict(),
    z.object({
        type: z.literal(131)
    }).strict(),
    z.object({
        type: z.literal(132),
        knightInfo: gameLogKnightInformationSchema
    }).strict(),
    z.object({
        type: z.literal(133),
        knightInfo: gameLogKnightInformationSchema
    }).strict(),
    z.object({
        type: z.literal(134)
    }).strict(),
    z.object({
        type: z.literal(135),
        cardEnum: z.enum(CardEnum)
    }).strict(),
    z.object({
        type: z.literal(136)
    }).strict(),
    z.object({
        type: z.literal(137),
        diceNumber: twoDiceSumSchema
    }).strict(),
    z.object({
        type: z.literal(138),
        diceNumber1: singleDieSchema,
        diceNumber2: singleDieSchema
    }).strict(),
    z.object({
        type: z.literal(139),
        playerCount: z.number().int().nonnegative()
    }).strict(),
    z.object({
        type: z.literal(140),
        playerColor: z.enum(PlayerColor)
    }).strict(),
    z.object({
        type: z.literal(141),
        firstDice: singleDieSchema,
        secondDice: singleDieSchema,
        eventDice: singleDieSchema.optional()
    }).strict(),
    z.object({
        type: z.literal(142)
    }).strict(),
    z.object({
        type: z.literal(143)
    }).strict(),
    z.object({
        type: z.literal(144),
        playerColor: z.enum(PlayerColor),
        amountToSelect: z.number().int().nonnegative(),
        amountShort: z.number().int().positive()
    }).strict()
]);
export const gameLogDataSchema = z.object({
    text: gameLogSchema,
    from: z.enum(PlayerColor).exactOptional(),
    specificRecipients: uniquePlayerColorsArraySchema.exactOptional(),
    toSpectators: z.literal(false).exactOptional()
}).strict();
export function validateGameLogData(data) {
    return validateState(gameLogDataSchema, data);
}
